import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./coupon-redeemed.page.scss";
import { Trans, useTranslation } from "react-i18next";

const CouponRedeemedPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const details = useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      organization: params.get("organization") || t("couponRedeemed.defaultOrganization"),
      course: params.get("course") === "true",
      backgroundcheck: params.get("backgroundcheck") === "true",
      orderId: params.get("order_id"),
    };
  }, [location.search, t]);

  const redeemedLabel = useMemo(() => {
    if (details.course && details.backgroundcheck) {
      return t("couponRedeemed.products.bundle");
    }

    if (details.backgroundcheck) {
      return t("couponRedeemed.products.background");
    }

    return t("couponRedeemed.products.course");
  }, [details.backgroundcheck, details.course, t]);

  return (
    <div className="coupon-redeemed">
      <div className="coupon-redeemed__card">
        <span className="coupon-redeemed__eyebrow">{t("couponRedeemed.eyebrow")}</span>
        <h1>{t("couponRedeemed.title")}</h1>
        <p className="coupon-redeemed__lead">
          <Trans
            i18nKey="couponRedeemed.lead"
            values={{ organization: details.organization, product: redeemedLabel }}
            components={{ organization: <strong />, product: <strong /> }}
          />
        </p>

        <div className="coupon-redeemed__summary">
          <div className="coupon-redeemed__summary-item">
            <span>{t("couponRedeemed.organization")}</span>
            <strong>{details.organization}</strong>
          </div>
          <div className="coupon-redeemed__summary-item">
            <span>{t("couponRedeemed.courseAccess")}</span>
            <strong>{t(details.course ? "common.included" : "common.notIncluded")}</strong>
          </div>
          <div className="coupon-redeemed__summary-item">
            <span>{t("couponRedeemed.backgroundCheck")}</span>
            <strong>
              {t(details.backgroundcheck ? "common.included" : "common.notIncluded")}
            </strong>
          </div>
        </div>

        <div className="coupon-redeemed__actions">
          {details.course ? (
            <button
              type="button"
              className="cf-navbar__links--link cf-navbar__links--link-primary"
              onClick={() => history.push("/course")}
            >
              {t("couponRedeemed.goToCourse")}
            </button>
          ) : null}

          {details.backgroundcheck ? (
            <button
              type="button"
              className="coupon-redeemed__secondary-btn"
              onClick={() =>
                history.push(
                  details.orderId
                    ? `/background?order_id=${encodeURIComponent(details.orderId)}`
                    : "/background",
                )
              }
            >
              {t("couponRedeemed.goToBackground")}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CouponRedeemedPage;
